var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"editor-box"},[_c('vue-ueditor-wrap',{attrs:{"config":_vm.ueConfig},on:{"ready":_vm.ready},model:{value:(_vm.formData[_vm.dataConfig.key]),callback:function ($$v) {_vm.$set(_vm.formData, _vm.dataConfig.key, $$v)},expression:"formData[dataConfig.key]"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }